import { SimpleCarousel } from '@eventbrite/collection-carousel';
import { LoadingCards } from '@eventbrite/eds-event-card';
import React from 'react';

interface CategoryEventsLoadingStateProps {
    numberOfEvents?: number;
}

export const CategoryEventsLoadingState: React.FunctionComponent<
    CategoryEventsLoadingStateProps
> = (props) => {
    const numberOfEvents =
        typeof props.numberOfEvents === 'number' ? props.numberOfEvents : 4;
    return (
        <SimpleCarousel
            slidesVisible={{ desktop: 4, tablet: 2 }}
            lazilyRenderOffScreenElements={true}
        >
            {[...Array(numberOfEvents).keys()].map((item: number) => (
                <div
                    key={`loading_card_${item}`}
                    style={{
                        width: '97%',
                        height: '400px',
                        marginTop: '8px',
                        marginBottom: '8px',
                    }}
                >
                    <LoadingCards
                        style="grid"
                        dynamicWidth={true}
                        cardCount={1}
                        dynamicHeight={true}
                    />
                </div>
            ))}
        </SimpleCarousel>
    );
};
